import React from "react";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import styled from "styled-components/macro";

import { Column } from "components/Layout";

import { Label } from "./Label";

const StyledToggleButton = styled(ToggleButton)`
  && {
    white-space: nowrap;
    text-transform: none;
  }
`;

export const ToggleButtons = ({
  name,
  label,
  options,
  tooltip,
  value,
  onChange,
  disabled,
}) => {
  const normalised = React.useMemo(
    () =>
      options.map(o =>
        typeof o === "object"
          ? { label: o.label, value: o.value }
          : { label: String(o), value: o },
      ),
    [options],
  );

  return (
    <Column fullWidth>
      <Label htmlFor={name} tooltip={tooltip}>
        {label}
      </Label>

      <ToggleButtonGroup
        value={value}
        onChange={onChange}
        aria-label={label}
        data-tour={label}
        size="small"
      >
        {normalised.map(option => (
          <StyledToggleButton
            key={option.value}
            data-tour={option.label}
            value={option.value}
            aria-label={option.label}
            disabled={disabled}
            title={option.label}
          >
            {option.label}
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>
    </Column>
  );
};
